/** @format */

import React from 'react';

export default function ProdPathAbout() {
  return (
    <>
      <article className="wrapper">
        <h2>A Better Way to Learn and Grow: The ProdigyPath Vision</h2>
        <div className="article">
          <section>
            <p>
              Welcome to Prodigy-Path-Server, the premier mentorship application
              designed to connect individuals who are seeking to learn new
              skills or gain experience in a particular field with experienced
              mentors who are willing to share their knowledge and skills.{' '}
            </p>
          </section>
          <section>
            <p>
              We understand that entering a new industry or trying to learn new
              skills can be a challenging experience, and our goal is to make
              this process easier and more accessible for everyone. Our platform
              provides a space for mentors and proteges to connect and share
              their expertise, helping to facilitate growth and learning for all
              involved.
            </p>
          </section>
          <section>
            <p>
              Our MVP includes a search function with filtering capabilities, a
              messaging feature, and the ability for mentors to approve protégés
              requests and share contact information. This allows for real-time
              communication and a seamless experience for both mentors and
              protégés.
            </p>
          </section>
          <section>
            <p>
              Whether you're just starting out in your career or looking to take
              your skills to the next level, Prodigy-Path-Server is here to
              support you every step of the way. We're dedicated to empowering
              the next generation of experts and helping individuals reach their
              full potential through mentorship. Join us today and start your
              journey towards success.
            </p>
          </section>
        </div>
      </article>
    </>
  );
}
